/* eslint-disable prefer-destructuring */
import React, { useState, useCallback } from 'react'
import axios from 'axios'

import md5 from 'md5'
import Legal from '../Legal/Legal'
import Rgpd from '../Rgpd/Rgpd'
import NameInput from '../FormInput/NameInput/NameInput'
import MailInput from '../FormInput/MailInput/MailInput'
import TelInput from '../FormInput/TelInput/TelInput'
import MoveSizeInput from '../FormInput/MoveSizeInput/MoveSizeInput'
import MoveDateInput from '../FormInput/MoveDateInput/MoveDateInput'
import HotLeadValidationScreen from '../FormValidationScreen/HotLeadValidationScreen'
import ColdLeadValidationScreen from '../FormValidationScreen/ColdLeadValidationScreen'

import Tracking from '../../../utils/helpers/Tracking'
import { getSourceParam } from '../../../utils/helpers/getSourceParam'
import * as DesBrasEnPlusLogo from '../../../assets/des-bras-en-plus-logo.png'
import * as S from './MoveForm.style'
import MoveContactDateInput from '../FormInput/MoveContactDateInput/MoveContactDateInput'

const initialState = {
  userName: {
    value: '',
    valid: false,
    clicked: false,
  },
  userMail: {
    value: '',
    valid: false,
    clicked: false,
  },
  userTel: {
    value: '',
    valid: false,
    clicked: false,
  },
  moveSize: {
    value: '',
    valid: false,
    clicked: false,
  },
  moveDate: {
    value: { value: null, label: '' },
    valid: false,
    clicked: false,
  },
  contactSlot: {
    value: { value: null, label: '' },
    valid: false,
    clicked: false,
  },
  isBienFinded: false,
  rgpdValid: false,
  messageErrorOnSubmit: {
    value: '',
  },
  isFormSended: false,
  isDataSending: false,
  isHotLead: false,
}

const MoveForm = ({ isLogicImmo }) => {
  const [state, setState] = useState(initialState)
  const handleIsBienFinded = useCallback(() => {
    setState(prev => ({
      ...prev,
      isBienFinded: !prev.isBienFinded,
    }))
  }, [])
  const handleRgpd = useCallback(() => {
    setState(prev => ({
      ...prev,
      rgpdValid: !prev.rgpdValid,
    }))
  }, [])
  const handleForm = () => {
    setState(prev => ({
      ...prev,
      isDataSending: true,
    }))
    const TransactionTypeRegexp = /transactiontypeid=([^&]+)/i.exec(window.location.href)
    const trimedTransactionType = TransactionTypeRegexp && /[0-9]{1}/.exec(TransactionTypeRegexp[1])[0]
    const TransactionTypeId = TransactionTypeRegexp ? trimedTransactionType : '0'
    const sourcePage = getSourceParam()
    const dataToSend = {
      lastname: state.userName.value,
      email: state.userMail.value,
      phone: state.userTel.value,
      surface: parseInt(state.moveSize.value, 10) || 0,
      moveDateOption: state.moveDate.value.value,
      isPropertyFound: state.isBienFinded,
      transactionType: parseInt(TransactionTypeId, 10) || 0,
      contactSlot: state.contactSlot.value.value,
      source: isLogicImmo ? 1 : 0,
      ...(sourcePage && { LeadSourcePage: sourcePage }),
    }
    axios
      .post(`/ser/api/Partner/move`, dataToSend)
      .then(() => {
        Tracking.PushInteraction({
          int_type: 'service-moove',
          int_description: 'completion',
          int_infos: 'moove-landing',
          email_lead: md5(dataToSend.email.toLowerCase()).toString(),
          form_profile: 'moover',
        })
        if (dataToSend.isPropertyFound) {
          setState(prev => ({
            ...prev,
            isHotLead: true,
          }))
        }

        setState(prev => ({
          ...prev,
          isFormSended: true,
        }))
      })
      .catch(error => {
        Tracking.PushInteraction({
          int_type: 'form-error',
          int_description: 'demenagement',
          int_infos: error.message,
        })

        if (error.response) {
          setState(prev => ({
            ...prev,
            isDataSending: false,
            messageErrorOnSubmit: {
              value: error.response.data.message,
            },
          }))
        }
      })
    return true
  }

  const content = (
    <>
      <S.StyledFormContainer>
        <S.LogoBrasContainer>
          <img src={DesBrasEnPlusLogo} alt="DES BRAS EN +, Le demenagement pour tous" />
        </S.LogoBrasContainer>

        <S.StyledTitle>Votre devis gratuit et sans engagement !</S.StyledTitle>
        <S.StyledError display={state.messageErrorOnSubmit.value}>{state.messageErrorOnSubmit.value}</S.StyledError>
        <S.StyledFormContent>
          <S.StyledInput>
            <NameInput state={state} setState={setState} />
          </S.StyledInput>
          <S.StyledInput>
            <MailInput state={state} setState={setState} />
          </S.StyledInput>
          <S.StyledInput>
            <TelInput state={state} setState={setState} />
          </S.StyledInput>
          <S.StyledInput>
            <MoveSizeInput state={state} setState={setState} />
          </S.StyledInput>
          <S.StyledInput>
            <MoveDateInput state={state} setState={setState} />
          </S.StyledInput>
          <S.StyledInput>
            <MoveContactDateInput state={state} setState={setState} />
          </S.StyledInput>
          <S.StyledProperty>
            <p>J&apos;ai trouvé mon bien</p>
            <label htmlFor="property1">
              <input id="property1" type="radio" name="bienTrouve" onChange={handleIsBienFinded} value checked={state.isBienFinded} /> Oui
            </label>
            <label htmlFor="property0">
              <input id="property0" type="radio" name="bienTrouve" onChange={handleIsBienFinded} value={false} checked={!state.isBienFinded} /> Non
            </label>
          </S.StyledProperty>
          <S.StyledLegal>
            <Legal value={state.rgpdValid} handleChange={handleRgpd} />
          </S.StyledLegal>
          <S.StyledCTA>
            <S.StyledBrandingButton
              onClick={handleForm}
              isLogicImmo={isLogicImmo}
              tag="button"
              size="lg"
              disabled={
                !(state.userName.valid && state.userMail.valid && state.userTel.valid && state.moveSize.valid && state.moveDate.valid && state.rgpdValid) || state.isDataSending
              }
              appearence="filled"
              id="LandingDemenagementFormButton"
              format="normal"
              style={{ width: '100%' }}
            >
              {state.isDataSending ? 'Envoi en cours' : 'Obtenir mon estimation'}
            </S.StyledBrandingButton>
          </S.StyledCTA>
          <S.StyledFooterForm>
            <Rgpd isLogicImmo={isLogicImmo} />
          </S.StyledFooterForm>
        </S.StyledFormContent>
      </S.StyledFormContainer>
    </>
  )
  return state.isFormSended ? (
    <S.StyledFormContainer>{state.isHotLead ? <HotLeadValidationScreen /> : <ColdLeadValidationScreen isLogicImmo={isLogicImmo} />}</S.StyledFormContainer>
  ) : (
    content
  )
}

/* const sizeCantBeNegative = val => {
  // if (moveSize === '') return
  if (moveSize < 1) setMoveSize('')
  // else setMoveSize(0)
} */

export default MoveForm
